import React, { useState } from 'react';

import { Action } from '@bypasslane/clover--web-lib-sprout-action';
import { FormGroup } from '@bypasslane/clover--web-lib-sprout-form-group';
import { Heading } from '@bypasslane/clover--web-lib-sprout-heading';
import { SecretTextField } from '@bypasslane/clover--web-lib-sprout-secret-text-field';
import PropTypes from 'prop-types';

import { withAuthLayout } from '../../../layouts/Auth';
import PasswordCriteria from './PasswordCriteria';

const Legend = () => <Heading headingLevel="h1">Reset Password</Heading>;

function ResetPasswordForm({ register, handleSubmit, pending, onSubmit, errors }) {
  const [newPassword, setNewPassword] = useState('');

  return (
    <div className="w-full md:w-[30rem] max-w-full">
      <FormGroup legend={<Legend />} isLegendVisible>
        <SecretTextField
          className="Reset-password__field"
          label="New Password"
          errorText={errors?.newPassword?.message}
          {...register('newPassword', {
            onChange: (e) => {
              setNewPassword(e.target.value);
            }
          })}
        />

        <PasswordCriteria newPassword={newPassword} />

        <SecretTextField
          className="Reset-password__field"
          label="Confirm New Password"
          errorText={errors?.confirmNewPassword?.message}
          {...register('confirmNewPassword')}
        />
      </FormGroup>
      <div>
        <Action
          className="mt-4"
          fullwidth
          variant="primary"
          disabled={pending}
          loading={pending}
          type="button"
          onClick={handleSubmit(onSubmit)}
        >
          Update Password
        </Action>
      </div>
    </div>
  );
}

export default withAuthLayout(ResetPasswordForm, { enableErrorBoundary: true });
ResetPasswordForm.propTypes = {
  register: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  ResetPasswordResponse: PropTypes.object,
  ResetPasswordError: PropTypes.object,
  pending: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
  errors: PropTypes.object,
  apiError: PropTypes.string,
  vestErrors: PropTypes.arrayOf(PropTypes.string),
  vestPassed: PropTypes.arrayOf(PropTypes.string),
  isVestValid: PropTypes.bool,
  vestResult: PropTypes.object
};
